import { useTranslation } from 'react-i18next';

import NotFound from 'shared/assets/not-found.png';

import { PageMessage } from '../PageMessage';

export function NotFoundMessage() {
  const { t } = useTranslation('components.messages.notFound');

  return (
    <PageMessage
      title={t('title')}
      dataTestId="not-found-message"
      image={NotFound}
      imageAlt={t('imageAlt')}
      isFullHeight={true}
    />
  );
}
